<template>
    <AuthCard v-if="loadForm">
        <template #title>
            <h1>Login</h1>
        </template>
        <template #form>
            <ValidationObserver>
                <form
                    action=""
                    @submit.prevent="submit"
                >
                    <Alert
                        v-if="resetSuccess"
                        type="success"
                        contentString="Your password has been reset. You may now log in with your new password."
                    />

                    <Alert
                        v-if="error"
                        type="error"
                        contentString="The username or password you provided is incorrect."
                    />

                    <ValidationProvider
                        name="name"
                        rules="required|email|max:255"
                        v-slot="{ errors }"
                    >
                        <v-text-field
                            id="email"
                            name="email"
                            label="Email Address"
                            v-model="form.email"
                            :error-messages="errors[0]"
                            outlined
                            :dense="$vuetify.breakpoint.xsOnly"
                        />
                    </ValidationProvider>

                    <ValidationProvider
                        name="password"
                        rules="required"
                        v-slot="{ errors }"
                    >
                        <v-text-field
                            type="password"
                            id="password"
                            name="password"
                            label="Password"
                            v-model="form.password"
                            :error-messages="errors[0]"
                            outlined
                            :dense="$vuetify.breakpoint.xsOnly"
                        />
                    </ValidationProvider>

                    <v-btn
                        width="100%"
                        height="48px"
                        color="primary"
                        type="submit"
                        class="mb-4"
                    >
                        Sign in
                    </v-btn>
                </form>
                <v-card-actions class="Auth__secondary-actions">
                    <v-btn
                        text
                        :x-small="$vuetify.breakpoint.xsOnly"
                        to="/register"
                    >
                        Register
                    </v-btn>

                    <v-btn
                        text
                        :x-small="$vuetify.breakpoint.xsOnly"
                        to="/forgot-password"
                    >
                        Forgot Password?
                    </v-btn>
                </v-card-actions>
            </ValidationObserver>
        </template>
    </AuthCard>
</template>
<script>
import { mapActions, mapMutations } from 'vuex';
import Alert from '@/components/Auth/Common/Alert';
import AuthCard from '@/components/Auth/Common/AuthCard';

export default {
    components: { AuthCard, Alert },

    data() {
        return {
            error: false,
            resetSuccess: false,
            loadForm: false,
            form: {
                email: '',
                password: ''
            }
        };
    },

    mounted() {
        this.me()
            .then(() => {
                this.$router.push({ name: 'Dashboard' });
            })
            .catch(() => {
                this.loadForm = true;
            });

        if (this.$route.query.resetSuccess) {
            this.resetSuccess = true;
        }
        this.toggleOverlay(false);
    },

    methods: {
        ...mapActions({
            signIn: 'auth/signIn',
            me: 'auth/me'
        }),

        ...mapMutations({
            toggleOverlay: 'overlay/toggle'
        }),

        async submit() {
            this.toggleOverlay(true);
            this.error = false;
            await this.signIn(this.form)
                .then((response) => {
                    /**
                     * Builder Users: ONLY get a dashboard.
                     *
                     * Support Users: to prevent a user that has been downgraded to support from accidentally accessing
                     * a data collection page that they previously had access to and
                     * getting kicked back to login screen because they don't have the proper permissions.
                     */
                    if (response.role === 'support' || response.role === 'builder') {
                        this.$router.replace({ name: 'Dashboard' });
                    } else {
                        /**
                         * If user auth is timed out, navigating or refreshing will save the current path
                         * & and redirect to login.
                         *
                         * If a path is set, redirect to that path instead of the dashboard after login.
                         */
                        const prevURL = localStorage.getItem('prevURL');
                        if (prevURL) {
                            localStorage.removeItem('prevURL');
                            this.$router.push({ path: prevURL });
                        } else {
                            this.$router.replace({ name: 'Dashboard' });
                        }
                    }
                })
                .catch((error) => {
                    if (error && error.response && error.response.status === 422) {
                        this.error = true;
                        this.toggleOverlay(false);
                    } else {
                        console.error('I am Error.', error);
                    }
                });
        }
    }
};
</script>
